import { locale, loadMessages, formatMessage, formatDate } from "devextreme/localization";

//devExtreme messages
import deMessages from "devextreme/localization/messages/de.json";
import enMessages from "devextreme/localization/messages/en.json";

//translations
import deTranslations from "localResouces/translations/de.json";
import enTranslations from "localResouces/translations/en.json";

export function getAvailableLocales() {
  return availableLocales;
}

export function loadLocale(uiLanguage, dataLanguage) {
  if (!uiLanguage || uiLanguage.includes("undefined")) {
    console.log("LocaleManager: Unsupported uiLanguage", uiLanguage);
    return;
  }
  if (!dataLanguage || dataLanguage.includes("undefined")) {
    console.log("LocaleManager: Unsupported dataLanguage", dataLanguage);
    return;
  }
  console.log("LocaleManager: Trying to load uiLanguage and dataLanguage", uiLanguage, dataLanguage);
  switch (uiLanguage) {
    case "de":
      console.log("LocaleManager: Messages and Translations", deMessages, deTranslations);
      loadMessages(deMessages);
      loadMessages(deTranslations);
      locale(dataLanguage);
      break;
    case "en":
      console.log("LocaleManager: Messages and Translations", enMessages, enTranslations);
      loadMessages(enMessages);
      loadMessages(enTranslations);
      locale(dataLanguage);
      break;
    default:
      console.log("LocaleManager: Using no locale (defaults to english/code fallback)");
      break;
  }
}

// function fakeOtherLanguage(dictionary, originalLanguage, fakeLanguage) {
//   if (originalLanguage === fakeLanguage) return dictionary;
//   return {[fakeLanguage]: dictionary[originalLanguage]};
// }

export function getTranslation(key, fallbackTranslation) {
  let result = formatMessage(key);
  //console.log("Translation for " + key, ": \"" +  result + "\" with Fallback: \"" + fallbackTranslation + "\"");
  return result || fallbackTranslation || missingTranslation;
}

export function formatShortDate(value) {
  let result = formatDate(value, "shortDate");
  //console.log("FormatShortDate of " + value + ": " + result);
  return result;
}

const missingTranslation = "[missing translation]";

const availableLocales = [
  {
    id: "de",
    text: "DE",
    desc: "deutsch",
    icon: "globe",
  },
  {
    id: "en",
    text: "EN",
    desc: "english",      
    icon: "globe",
  }
];


